import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { ArrayField } from 'informed';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { useFieldState } from 'informed';
import defaultClasses from './claimItemInformation.module.css';
import ClaimItem from './claimItem';
import { Button } from '../../../../components';

var ClaimItemInformation = function ClaimItemInformation(_ref) {
  var _orderDetails$line_de, _orderDetails$line_de2;

  var propClasses = _ref.classes,
      order = _ref.order,
      orderDetails = _ref.orderDetails,
      handleItemChange = _ref.handleItemChange,
      selectedItemNumber = _ref.selectedItemNumber;
  var classes = useStyle(defaultClasses, propClasses);

  var _useState = useState((orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$line_de = orderDetails.line_details) === null || _orderDetails$line_de === void 0 ? void 0 : _orderDetails$line_de.length) > 1 ? 1 : 0),
      _useState2 = _slicedToArray(_useState, 2),
      showAddItem = _useState2[0],
      setShowAddItem = _useState2[1];

  var numberOfOrderItem = orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$line_de2 = orderDetails.line_details) === null || _orderDetails$line_de2 === void 0 ? void 0 : _orderDetails$line_de2.length;

  var handleAddClaimLine = function handleAddClaimLine() {
    setShowAddItem(function (prevState) {
      return prevState + 1;
    });
  };

  return React.createElement("div", null, React.createElement("h5", {
    className: classes.sectionTitle
  }, "Claim Item Information"), React.createElement(ArrayField, {
    field: "claims_items"
  }, function (_ref2) {
    var add = _ref2.add;
    return React.createElement(React.Fragment, null, React.createElement(ArrayField.Items, null, function (_ref3) {
      var _orderDetails$line_de3;

      var remove = _ref3.remove,
          index = _ref3.index,
          field = _ref3.field;

      if ((orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$line_de3 = orderDetails.line_details) === null || _orderDetails$line_de3 === void 0 ? void 0 : _orderDetails$line_de3.length) > index) {
        var _useFieldState = useFieldState("".concat(field, ".item_name")),
            value = _useFieldState.value;

        return React.createElement(ClaimItem, {
          index: index,
          field: field,
          remove: remove,
          order: order,
          orderDetails: orderDetails,
          handleItemChange: handleItemChange,
          selectedItemNumber: selectedItemNumber,
          setShowAddItem: setShowAddItem,
          value: value
        });
      }
    }), showAddItem >= 1 && showAddItem < numberOfOrderItem && React.createElement("div", {
      className: classes.addItem
    }, React.createElement(Button, {
      priority: "normal",
      onClick: function onClick() {
        add();
        handleAddClaimLine();
      },
      "aria-label": "Add item to claim"
    }, "ADD ANOTHER ITEM TO CLAIM")));
  }));
};

export default ClaimItemInformation;